// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__eajtu","colMin":"styles_colMin__3mH82","colCheckbox":"styles_colCheckbox__l1c5o"};